import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPhotosDuplicates from "@/pages/admin/AdminPhotosDuplicates";

export const Route = createFileRoute("/admin/photos/duplicates")({
  head: () => pageHead("Admin \u2014 Photos \u2014 Duplicates \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPhotosDuplicates,
});
